import React from 'react';
import { Search, Filter } from 'lucide-react';
import { Deal } from '../../types';

interface DueDiligenceFiltersProps {
  deals: Deal[];
  categories: Array<{ id: string; name: string }>;
  selectedDeal: Deal | null;
  selectedCategory: string | null;
  selectedStatus: string | null;
  onDealChange: (deal: Deal | null) => void;
  onCategoryChange: (category: string | null) => void;
  onStatusChange: (status: string | null) => void;
  onSearch: (term: string) => void;
}

export default function DueDiligenceFilters({
  deals,
  categories,
  selectedDeal,
  selectedCategory,
  selectedStatus,
  onDealChange,
  onCategoryChange,
  onStatusChange,
  onSearch
}: DueDiligenceFiltersProps) {
  return (
    <div className="flex flex-wrap gap-4">
      <div className="flex-1 relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
        <input
          type="text"
          placeholder="Search tasks..."
          onChange={(e) => onSearch(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
        />
      </div>

      <select
        value={selectedDeal?.id || ''}
        onChange={(e) => {
          const deal = deals.find(d => d.id === e.target.value);
          onDealChange(deal || null);
        }}
        className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="">All Deals</option>
        {deals.map((deal) => (
          <option key={deal.id} value={deal.id}>{deal.name}</option>
        ))}
      </select>

      <select
        value={selectedCategory || ''}
        onChange={(e) => onCategoryChange(e.target.value || null)}
        className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="">All Categories</option>
        {categories.map((category) => (
          <option key={category.id} value={category.id}>{category.name}</option>
        ))}
      </select>

      <select
        value={selectedStatus || ''}
        onChange={(e) => onStatusChange(e.target.value || null)}
        className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="">All Status</option>
        <option value="pending">Pending</option>
        <option value="in_progress">In Progress</option>
        <option value="completed">Completed</option>
      </select>
    </div>
  );
}